import * as React from 'react';
import classNames from 'classnames';
import './style.scss';
import './style.scss';
import { Link as GLink } from 'gatsby-plugin-react-i18next';

interface Props {
  href: string;
  language?: string;
  className?: string;
  additionalClassName?: string;
  underlined?: boolean;
  children: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  itemProp?: string;
}

const Link: React.SFC<Props> = ({
  href,
  language,
  className,
  additionalClassName,
  children,
  underlined,
  onMouseLeave,
  onMouseEnter,
  itemProp,
}) => {
  return (
    <GLink
      to={href}
      className={classNames(
        className,
        {
          [`${'underlined'}`]: underlined,
        },
        additionalClassName
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      itemProp={itemProp}
      language={language}
      // passHref
    >
      {/* <a
      > */}
      {children}
      {/* </a> */}
    </GLink>
  );
};

export default Link;
